import React from 'react';
import { useUser } from '@lore/auth';
import { useConnect } from '@lore/query-connect';
import ParentLayout from '../Layout';
import Navigation from '../../../dialogs_common/Navigation';
import Urls from '../Urls';
import Form from './Form';
import { PayloadStates } from '@lore/utils';
import useRouter from '../../../hooks/useRouter';

export default function Layout(props) {
  const { location, history, match } = useRouter();
  const user = useUser();
  const project = useConnect('project.byId', {
    id: Number(match.params.projectId)
  });

  if (project.state === PayloadStates.FETCHING) {
    return null;
  }

  return (
    <ParentLayout
      project={project}
      page="Outcome"
      title="What do you and your students hope to achieve with this project?"
      description={(
        <>
          <span className="font-semibold italic">TIP</span>: What key learning do you
          hope to see? What is the difference you want to make?
        </>
      )}
    >
      <Form
        user={user}
        project={project}
        navigation={(
          <Navigation v5={true} activeStep={2} steps={19}/>
        )}
        onPrevious={(newData) => history.push(Urls(project).TITLE)}
        onNext={(newData) => history.push(Urls(project).DEMONSTRATION)}
        onSkip={() => history.push(Urls(project).DEMONSTRATION)}
        onExit={() => history.push(Urls(project).PROJECT_EDIT)}
      />
    </ParentLayout>
  );
};
